import { render, staticRenderFns } from "./Pipes.vue?vue&type=template&id=ca41db4c&"
import script from "./Pipes.vue?vue&type=script&lang=js&"
export * from "./Pipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports